<meta name="viewport"
    content="user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height, target-densitydpi=device-dpi" />
<div class="container-fluid">
    <app-page-title title="Dashboard"></app-page-title>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <label class="label" style="display: flex;justify-content:center;">View By</label>
                <div class="mobile-dashboard" style="display: flex;justify-content:center;">
                    <div class="btn-group col-lg-4 col-md-6 col-sm-12 col-12 btn-group-example" role="group">
                        <button type="button" [ngClass]="groupingType ==='day'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterDay()">Day</button>
                        <button type="button" [ngClass]="groupingType ==='month'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterMonth()">Month</button>
                        <button type="button" [ngClass]="groupingType ==='quarter'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterQuarter()">Quarter</button>
                        <button type="button" [ngClass]="groupingType ==='year'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterYear()">Year</button>
                        <button type="button" [ngClass]="groupingType ==='range'? 'btn-primary':'btn-outline-primary'"
                            class="btn w-20" (click)="filterRange()">Range</button>
                    </div>
                </div>
            </div>
            <br/>
            <div class="row" style="margin-top :0px !important;">
                <div class="col-lg-12 col-md-4 col-sm-12" style="display: flex;justify-content:center;">
                    <div *ngIf="!compareData" class="col-lg-4 col-md-6 col-sm-12 col-12" style="display: flex;">
                        <button class="btn btn-block btn-primary" (click)="openComparison()">Compare
                            Data</button>
                    </div>
                </div>
                <div class="col-lg-12 col-md-4 col-sm-12" style="display: flex;justify-content:center;">
                    <div *ngIf="compareData" class="col-lg-4 col-md-6 col-sm-12 col-12"style="display: flex;">
                        <button class="btn btn-block btn-danger" (click)="closedComparison()">Closed Comparison</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div #dll class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Operating Unit</label>
                    <ngx-dropdown-treeview [config]="config" *ngIf="!showSingle" [items]="operatingUnitList"
                        (selectedChange)="updateOperating($event)" buttonClass="btn-outline-primary">
                    </ngx-dropdown-treeview>
                    <ngx-dropdown-treeview-select *ngIf="showSingle" [items]="operatingUnitList"
                        [(value)]="operatingSelSingleVal" buttonClass="btn-outline-primary" [disabled]="showSingle">
                    </ngx-dropdown-treeview-select>
                </div>
                
                <div *ngIf="groupingType==='day' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Date</label>
                    <input [(ngModel)]="selDate"  class="form-control"
                        placeholder="dd/MM/yyyy" type="date">
                </div>
                <div *ngIf="(groupingType==='month' || groupingType==='year' || groupingType==='range'|| groupingType==='quarter') && !compareData"
                    class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Year</label>
                    <ng-select [items]="years" bindValue="year" [(ngModel)]="selYear" (ngModelChange)="selYearChange()">
                    </ng-select>
                </div>

                <div *ngIf="groupingType==='range' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Month From (Year {{selYear}})</label>
                    <ng-select [items]="monthsFrom" bindValue="month" bindLabel="desc" [(ngModel)]="selMonthFrom"
                        (change)="selMonthFromChange()">
                    </ng-select>
                </div>

                <div *ngIf="groupingType==='range' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Month To (Year {{selYear}})</label>
                    <ng-select [items]="monthsTo" bindValue="month" bindLabel="desc" [(ngModel)]="selMonthTo"
                        (change)="selMonthToChange()">
                    </ng-select>
                </div>

                <div *ngIf="groupingType==='month' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Month</label>
                    <ng-select [items]="months" bindValue="month" bindLabel="desc" [(ngModel)]="selMonth"
                       >
                    </ng-select>
                </div>
                <div *ngIf="groupingType==='quarter' && !compareData" class="col-lg-3 col-md-6 col-sm-12">
                    <label class="label">Quarter</label>
                    <ng-select [(ngModel)]="selectedQuarter" (change)="selQuarterChange()">
                        <ng-option *ngFor="let quarter of QuaterList" [value]="quarter.value">{{quarter.title}}</ng-option>
                     </ng-select>
                </div>

            </div>
            <div class="row col-lg-2 col-md-4 col-sm-12">
                &nbsp;
            </div>
            <div class="row">
                <div class="col-lg-2 col-md-4 col-sm-12" style="align-self: end;">
                    <button class="btn btn-block btn-primary" (click)="filter()">Filter</button>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-4 col-sm-12">
                    <h4>{{chartHeaderJoin()}}</h4>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-2 col-md-4 col-sm-12">
                    <h4>{{operatingSelSingleValName}}</h4>
                </div>
            </div>

            <div *ngIf="!compareData">
                <div *ngIf="groupingType =='day'" class="row">
                    <div class="row">&nbsp;</div>

                    <div style="text-align-last: center;">
                        <h6 style="font-size:14px !important;">Total No. of Submission Chart ({{this.newcurrentDate | date: 'dd/MM/yyyy'}})</h6>
                    </div>
                   
                    <div id="dashboardPieChart"></div>

                    <div class="row">
                        <button class="btn btn-primary mo-mb-2 ms-1" type="button"
                            (click)="estateProductivityPieChartDetailsCollapsed = !estateProductivityPieChartDetailsCollapsed">
                            Show Chart Details
                        </button>
                        <div class="collapse" [ngbCollapse]="estateProductivityPieChartDetailsCollapsed">
                            <div class="card card-body mb-0">

                                <div class="card-body">
                                    <div class="row mb-md-2">
                                        <div class="col-sm-12 col-md-9 col-lg-10">
                                            <div class="dataTables_length table-responsive">
                                                <label class="d-inline-flex align-items-center">Show
                                                    <select name="tickets-table_length" aria-controls="tickets-table"
                                                        name="pageSize" [(ngModel)]="pageSize"
                                                        class="form-control form-control-sm mx-2"
                                                        (change)="pageSizeChange($event)">
                                                        <option [ngValue]="10">10</option>
                                                        <option [ngValue]="25">25</option>
                                                        <option [ngValue]="50">50</option>
                                                        <option [ngValue]="100">100</option>
                                                    </select> entries</label>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="table-responsive">
                                        <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead class="">
                                                <tr>
                                                    <th></th>
                                                    <th>Status</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let items1 of estateProducitivtyPieChartData;let i = index">
                                                <tr>
                                                    <td align="center">
                                                        <a class="expand-row" (click)="chartDetailsDetails(i)">
                                                            +
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items1.name"></ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="items1.total"></ngb-highlight>
                                                    </td>
                                                    
                                                </tr>
                                                <tr *ngIf="showChartDetailsDetails[i]" class="sub-table no-bg">
                                                    <td colspan="15" class="p-0">
                                                        <table class="table mb-0 table-striped">
                                                            <thead class="bg-dark text-white">
                                                                <tr>
                                                                    <th>OU</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let items of items1.items;let e = index">
                                                                    <td>
                                                                        <ngb-highlight [result]="items.title">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row justify-content-md-between align-items-md-center mt-2">
                                        <div class="col-sm-12 col-md-5">
                                            <div class="dataTables_info mb-2" id="tickets-table_info" role="status"
                                                aria-live="polite">
                                                Showing
                                                {{startIndex}} to
                                                {{endIndex}} of {{totalRecords}}
                                                entries
                                            </div>
                                        </div>
                                        <!-- Pagination -->
                                        <div class="col-sm-12 col-md-5">
                                            <div class="text-md-right float-md-end pagination-rounded">
                                                <ngb-pagination [collectionSize]="totalRecords" [(page)]="page"
                                                    [pageSize]="pageSize" [maxSize]="5" [rotate]="true"
                                                    [boundaryLinks]="true" (pageChange)="pageChange($event)">
                                                </ngb-pagination>
                                            </div>
                                        </div>
                                        <!-- End Pagination -->
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>

                </div>
            </div>
                   


            <div *ngIf="!compareData">
                <div *ngIf="groupingType !=='day'" class="row">
                    <div class="row">
                        <span style="font-weight:bold;">{{chartTitle}}</span>
                    </div>
                    
                    <div id="dashboardBarCropActualvsBudget"></div>
                    <div class="row">
                        <button class="btn btn-primary mo-mb-2 ms-1" type="button"
                            (click)="cropActualvsBudgetchartDetailsCollapsed = !cropActualvsBudgetchartDetailsCollapsed">
                            Show Chart Details
                        </button>
                        <div class="collapse" [ngbCollapse]="cropActualvsBudgetchartDetailsCollapsed">
                            <div class="card card-body mb-0">

                                <div class="card-body">
                                    <div class="row mb-md-2">
                                        <div class="col-sm-12 col-md-9 col-lg-10">
                                            <div class="dataTables_length table-responsive">
                                                <label class="d-inline-flex align-items-center">Show
                                                    <select name="tickets-table_length" aria-controls="tickets-table"
                                                        name="pageSize" [(ngModel)]="pageSize"
                                                        class="form-control form-control-sm mx-2"
                                                        (change)="pageSizeChange($event)">
                                                        <option [ngValue]="10">10</option>
                                                        <option [ngValue]="25">25</option>
                                                        <option [ngValue]="50">50</option>
                                                        <option [ngValue]="100">100</option>
                                                    </select> entries</label>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="table-responsive">
                                        <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead class="">
                                                <tr>
                                                    <th></th>
                                                    <th>{{SubChartLabel}}</th>
                                                    <th>Crop Actual Total</th>
                                                    <th>Crop Budget Total</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let item of cropChartData;let i = index">
                                                <tr>
                                                    <td align="center">
                                                        <a class="expand-row" (click)="chartDetailsDetails(i)">
                                                            +
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.header"></ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.cropActualTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.cropBudgetTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                   
                                                </tr>
                                                <tr *ngIf="showChartDetailsDetails[i]" class="sub-table no-bg">

                                                    <td align="center"> </td>
                                                    <td colspan="15" class="p-0">
                                                        <table class="table mb-0 table-striped">
                                                            <thead class="bg-dark text-white">
                                                                <tr>
                                                                    <th>OU</th>
                                                                    <th>Crop Actual</th>
                                                                    <th>Crop Budget</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let subItem of item.items;let e = index">
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.title">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.actual| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.budget| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                   
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row justify-content-md-between align-items-md-center mt-2">
                                        <div class="col-sm-12 col-md-5">
                                            <div class="dataTables_info mb-2" id="tickets-table_info" role="status"
                                                aria-live="polite">
                                                Showing
                                                {{startIndex}} to
                                                {{endIndex}} of {{totalRecords}}
                                                entries
                                            </div>
                                        </div>
                                        <!-- Pagination -->
                                        <div class="col-sm-12 col-md-5">
                                            <div class="text-md-right float-md-end pagination-rounded">
                                                <ngb-pagination [collectionSize]="totalRecords" [(page)]="page"
                                                    [pageSize]="pageSize" [maxSize]="5" [rotate]="true"
                                                    [boundaryLinks]="true" (pageChange)="pageChange($event)">
                                                </ngb-pagination>
                                            </div>
                                        </div>
                                        <!-- End Pagination -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row">&nbsp;</div>
                    
                    <div id="dashboardBarLineChartrainfall"></div>
                    <div class="row">
                        <button class="btn btn-primary mo-mb-2 ms-1" type="button"
                            (click)="estateProductivityRainFallchartDetailsCollapsed = !estateProductivityRainFallchartDetailsCollapsed">
                            Show Chart Details
                        </button>
                        <div class="collapse" [ngbCollapse]="estateProductivityRainFallchartDetailsCollapsed">
                            <div class="card card-body mb-0">

                                <div class="card-body">
                                    <div class="row mb-md-2">
                                        <div class="col-sm-12 col-md-9 col-lg-10">
                                            <div class="dataTables_length table-responsive">
                                                <label class="d-inline-flex align-items-center">Show
                                                    <select name="tickets-table_length" aria-controls="tickets-table"
                                                        name="pageSize" [(ngModel)]="pageSize"
                                                        class="form-control form-control-sm mx-2"
                                                        (change)="pageSizeChange($event)">
                                                        <option [ngValue]="10">10</option>
                                                        <option [ngValue]="25">25</option>
                                                        <option [ngValue]="50">50</option>
                                                        <option [ngValue]="100">100</option>
                                                    </select> entries</label>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="table-responsive">
                                        <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead class="">
                                                <tr>
                                                    <th></th>
                                                    <th>{{SubChartLabel}}</th>
                                                    <th>RainFallTotal</th>
                                                    <th>ProductivityTotal</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let item of estateProductivityRainFallChartData;let i = index">
                                                <tr>
                                                    <td align="center">
                                                        <a class="expand-row" (click)="chartDetailsDetails(i)">
                                                            +
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.header"></ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.rainFallTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.productivityTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    
                                                </tr>
                                                <tr *ngIf="showChartDetailsDetails[i]" class="sub-table no-bg">

                                                    <td align="center"> </td>
                                                    <td colspan="15" class="p-0">
                                                        <table class="table mb-0 table-striped">
                                                            <thead class="bg-dark text-white">
                                                                <tr>
                                                                    <th>OU</th>
                                                                    <th>Rainfall</th>
                                                                    <th>Productivity</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let subItem of item.items;let e = index">
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.title">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.rainfall| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.productivity| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row justify-content-md-between align-items-md-center mt-2">
                                        <div class="col-sm-12 col-md-5">
                                            <div class="dataTables_info mb-2" id="tickets-table_info" role="status"
                                                aria-live="polite">
                                                Showing
                                                {{startIndex}} to
                                                {{endIndex}} of {{totalRecords}}
                                                entries
                                            </div>
                                        </div>
                                        <!-- Pagination -->
                                        <div class="col-sm-12 col-md-5">
                                            <div class="text-md-right float-md-end pagination-rounded">
                                                <ngb-pagination [collectionSize]="totalRecords" [(page)]="page"
                                                    [pageSize]="pageSize" [maxSize]="5" [rotate]="true"
                                                    [boundaryLinks]="true" (pageChange)="pageChange($event)">
                                                </ngb-pagination>
                                            </div>
                                        </div>
                                        <!-- End Pagination -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">&nbsp;</div>

                    <div id="dashboardBarLineChartHarvester"></div>
                    <div class="row">
                        <button class="btn btn-primary mo-mb-2 ms-1" type="button"
                            (click)="estateHarversterchartDetailsCollapsed = !estateHarversterchartDetailsCollapsed">
                            Show Chart Details
                        </button>
                        <div class="collapse" [ngbCollapse]="estateHarversterchartDetailsCollapsed">
                            <div class="card card-body mb-0">

                                <div class="card-body">
                                    <div class="row mb-md-2">
                                        <div class="col-sm-12 col-md-9 col-lg-10">
                                            <div class="dataTables_length table-responsive">
                                                <label class="d-inline-flex align-items-center">Show
                                                    <select name="tickets-table_length" aria-controls="tickets-table"
                                                        name="pageSize" [(ngModel)]="pageSize"
                                                        class="form-control form-control-sm mx-2"
                                                        (change)="pageSizeChange($event)">
                                                        <option [ngValue]="10">10</option>
                                                        <option [ngValue]="25">25</option>
                                                        <option [ngValue]="50">50</option>
                                                        <option [ngValue]="100">100</option>
                                                    </select> entries</label>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="table-responsive">
                                        <table id="basic-datatable"
                                            class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                                            <thead class="">
                                                <tr>
                                                    <th></th>
                                                    <th>{{SubChartLabel}}</th>
                                                    <th>HarversterTotal</th>
                                                    <th>TaskTotal</th>
                                                    <th>TaskHarversterTotal</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let item of estateHarversterChartData;let i = index">
                                                <tr>
                                                    <td align="center">
                                                        <a class="expand-row" (click)="chartDetailsDetails(i)">
                                                            +
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.header"></ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.harversterTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.taskTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                    <td>
                                                        <ngb-highlight [result]="item.taskHarversterTotal| number
                                                        : '1.2-2'">
                                                        </ngb-highlight>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="showChartDetailsDetails[i]" class="sub-table no-bg">

                                                    <td align="center"> </td>
                                                    <td colspan="15" class="p-0">
                                                        <table class="table mb-0 table-striped">
                                                            <thead class="bg-dark text-white">
                                                                <tr>
                                                                    <th>OU</th>
                                                                    <th>Task</th>
                                                                    <th>Harverster</th>
                                                                    <th>TaskHarverster</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let subItem of item.items;let e = index">
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.title">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.task| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.harverster| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                    <td>
                                                                        <ngb-highlight [result]="subItem.taskHarverster| number
                                                            : '1.2-2'">
                                                                        </ngb-highlight>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row justify-content-md-between align-items-md-center mt-2">
                                        <div class="col-sm-12 col-md-5">
                                            <div class="dataTables_info mb-2" id="tickets-table_info" role="status"
                                                aria-live="polite">
                                                Showing
                                                {{startIndex}} to
                                                {{endIndex}} of {{totalRecords}}
                                                entries
                                            </div>
                                        </div>
                                        <!-- Pagination -->
                                        <div class="col-sm-12 col-md-5">
                                            <div class="text-md-right float-md-end pagination-rounded">
                                                <ngb-pagination [collectionSize]="totalRecords" [(page)]="page"
                                                    [pageSize]="pageSize" [maxSize]="5" [rotate]="true"
                                                    [boundaryLinks]="true" (pageChange)="pageChange($event)">
                                                </ngb-pagination>
                                            </div>
                                        </div>
                                        <!-- End Pagination -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row">&nbsp;</div>
                   
                </div>

                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='day'"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Daily Crop</p>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{dailyMt | number : '1.2-2'}} mt</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{dailyBudget | number
                                                : '1.2-2'}} mt</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="dailyVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{dailyVarMt | number : '1.2-2'}} mt</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day' || groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='month'">
                                    <i class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{mtdText}}
                                </p>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{monthlyMt | number : '1.2-2'}} mt</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{monthlyBudget |
                                                number : '1.2-2'}} mt</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="monthlyVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{monthlyVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="monthlyVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{monthlyVarMt | number : '1.2-2'}} mt</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12"
                        *ngIf="groupingType==='day' || groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"
                                    [class.selected-grouping]="groupingType ==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                                    <i class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{ytdText}}
                                </p>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{yearlyMt | number : '1.2-2'}} mt</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{yearlyBudget | number
                                                : '1.2-2'}} mt</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="yearlyVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{yearlyVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="yearlyVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{yearlyVarMt | number : '1.2-2'}} mt</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="card">
                            <div class="card-body ext-card">
                                <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yphText}}
                                </p>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{yphMt | number : '1.2-2'}} mt/ha</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{yphBudget | number :
                                                '1.2-2'}} mt/ha</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="yphVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{yphVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="yphVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{yphVarMt | number : '1.2-2'}} mt/ha</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"><i
                                    class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yphmonthText}}
                            </p>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{yphMDTMonth | number : '1.2-2'}} mt/ha</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{yphMDTMonthBudget |
                                                number : '1.2-2'}} mt/ha</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="yphMDTMonthVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{yphMDTMonthVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="yphMDTMonthVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{yphMDTMonthVarMt | number : '1.2-2'}} mt/ha</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12"
                    *ngIf="groupingType === 'month'">
                    <div class="card ext-card">
                        <div class="card-body">
                            <p class="text-muted mb-4 font-size-20"
                                [class.selected-grouping]="groupingType ==='month'">
                                <i class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{ytdText}}
                            </p>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div>
                                        <h5>{{yearlyMt | number : '1.2-2'}} mt</h5>
                                        <p class="text-muted text-truncate mb-0">Budget: {{yearlyBudget | number
                                            : '1.2-2'}} mt</p>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                    <div class="row">
                                        <div class="d-flex">
                                            <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                [ngClass]="yearlyVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                {{yearlyVarPer | number : '1.2-2'}} %</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="d-flex">
                                            <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                [ngClass]="yearlyVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                {{yearlyVarMt | number : '1.2-2'}} mt</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day' || groupingType==='month'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"><i
                                    class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yphyearText}}
                            </p>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{yphMDTYear | number : '1.2-2'}} mt/ha</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{yphMDTYearBudget |
                                                number : '1.2-2'}} mt/ha</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="yphMDTYearVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{yphMDTYearVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="yphMDTYearVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{yphMDTYearVarMt | number : '1.2-2'}} mt/ha</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="groupingType==='day' || groupingType==='month' || groupingType==='year' || groupingType==='range'|| groupingType==='quarter'">
                        <div class="card ext-card">
                            <div class="card-body">
                                <p class="text-muted mb-4 font-size-20"><i
                                        class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Mature Area</p>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div>
                                            <h5>{{haMt | number : '1.2-2'}} ha</h5>
                                            <p class="text-muted text-truncate mb-0">Budget: {{haBudget | number
                                                : '1.2-2'}} ha</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 variance-container">
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="haVarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{haVarPer | number : '1.2-2'}} %</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="d-flex">
                                                <span class="text-truncate">Var: </span><span class="badge font-size-12"
                                                    [ngClass]="haVarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                    {{haVarMt  | number : '1.2-2'}} ha</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="compareData">
                <div class="row">
                    <div class="col-6">

                        <div class="row offset-lg-4">
                            <div *ngIf="groupingType==='day' && compareData" class="col-12">
                                <label class="label">Date</label>
                                <input [(ngModel)]="compareDate1" (change)="compareDate1Change()" class="form-control"
                                    placeholder="dd/MM/yyyy" type="date">
                            </div>

                            <div *ngIf="(groupingType==='month' || groupingType==='year' || groupingType==='range'|| groupingType ==='quarter') && compareData"
                                class="col-12">
                                <label class="label">Year</label>
                                <ng-select [items]="years" bindValue="year" [(ngModel)]="compareYearSel1"
                                    (ngModelChange)="selYearChangeCom(true)">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='range' && compareData" class="col-12">
                                <label class="label">Month From (Year {{compareYearSel1}})</label>
                                <ng-select [items]="compareMonthsFrom1" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthFromSel1" (change)="selMonthFromCompareChange(true)">
                                </ng-select>
                            </div>
                            <div *ngIf="groupingType==='quarter' && compareData" class="col-12">
                                <label class="label">Quarter</label>
                                <ng-select [(ngModel)]="compareQuarter1" (change)="compareDate1Change()">
                                    <ng-option *ngFor="let quarter of QuaterList" [value]="quarter.value">{{quarter.title}}</ng-option>
                                 </ng-select>
                            </div>
                            <div *ngIf="groupingType==='range' && compareData" class="col-12">
                                <label class="label">Month To (Year {{compareYearSel1}})</label>
                                <ng-select [items]="compareMonthsTo1" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthToSel1" (change)="compareDate1Change()">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='month' && compareData" class="col-12">
                                <label class="label">Month</label>
                                <ng-select [items]="compareMonths1" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthSel1" (change)="compareDate1Change()">
                                </ng-select>
                            </div>

                        </div>
                        <br />
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType ==='day'">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Daily Crop
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{daily1Mt | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{daily1Budget | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-muted card-variance">Var: </span><span
                                                        class="badgE font-size-12 card-variance"
                                                        [ngClass]="daily1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily1VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-muted card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="daily1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily1VarMt | number : '1.2-2'}} mt
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12"
                            *ngIf="groupingType==='day' || groupingType==='month'">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{mtdTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{monthly1Mt | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{monthly1Budget | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="monthly1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly1VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="monthly1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly1VarMt | number : '1.2-2'}} mt
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12"
                            *ngIf="groupingType==='day' || groupingType === 'month' || groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{ytdTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yearly1Mt | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly1Budget | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly1VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly1VarMt | number : '1.2-2'}} mt
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yphTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yph1Mt | number : '1.2-2'}} mt/ha</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yph1Budget | number : '1.2-2'}}
                                                mt/ha</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="yph1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yph1VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yph1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yph1VarMt | number : '1.2-2'}} mt/ha
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="offset-lg-4 col-lg-8 col-md-12 col-sm-12">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{matureAreaTextCompare1}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{ha1Mt | number : '1.2-2'}} ha</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{ha1Budget | number : '1.2-2'}}
                                                ha</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="ha1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{ha1VarMt | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="ha1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{ha1VarPer | number : '1.2-2'}} ha
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">

                        <div class="row col-lg-8 col-md-12 col-sm-12">
                            <div *ngIf="groupingType==='day' && compareData" class="col-12">
                                <label class="label">Date</label>
                                <input [(ngModel)]="compareDate2" (change)="compareDate2Change()" class="form-control"
                                    placeholder="dd/MM/yyyy" type="date">
                            </div>

                            <div *ngIf="(groupingType==='month' || groupingType==='year' || groupingType==='range'|| groupingType ==='quarter') && compareData"
                                class="col-12">
                                <label class="label">Year</label>
                                <ng-select [items]="years" bindValue="year" [(ngModel)]="compareYearSel2"
                                    (ngModelChange)="selYearChangeCom(false)">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='range' && compareData" class="col-12">
                                <label class="label">Month From (Year {{compareYearSel2}})</label>
                                <ng-select [items]="compareMonthsFrom2" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthFromSel2" (change)="selMonthFromCompareChange(false)">
                                </ng-select>
                            </div>

                            <div *ngIf="groupingType==='range' && compareData" class="col-12">
                                <label class="label">Month To (Year {{compareYearSel2}})</label>
                                <ng-select [items]="compareMonthsTo2" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthToSel2" (change)="compareDate2Change()">
                                </ng-select>
                            </div>
                            <div *ngIf="groupingType==='quarter' && compareData" class="col-12">
                                <label class="label">Quarter</label>
                                <ng-select [(ngModel)]="compareQuarter2" (change)="compareDate2Change()">
                                    <ng-option *ngFor="let quarter of QuaterList" [value]="quarter.value">{{quarter.title}}</ng-option>
                                 </ng-select>
                            </div>
                            <div *ngIf="groupingType==='month' && compareData" class="col-12">
                                <label class="label">Month</label>
                                <ng-select [items]="compareMonths2" bindValue="month" bindLabel="desc"
                                    [(ngModel)]="compareMonthSel2" (change)="compareDate2Change()">
                                </ng-select>
                            </div>

                        </div>
                        <br />
                        <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="groupingType ==='day'">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>Daily Crop
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{daily2Mt | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{daily2Budget | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-muted card-variance">Var: </span><span
                                                        class="badgE font-size-12 card-variance"
                                                        [ngClass]="daily1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily2VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-muted card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="daily1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{daily2VarMt | number : '1.2-2'}} mt
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12"
                            *ngIf="groupingType==='day' || groupingType==='month'">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{mtdTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{monthly2Mt | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{monthly2Budget | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="monthly1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly2VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="monthly1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{monthly2VarMt | number : '1.2-2'}} mt
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12"
                            *ngIf="groupingType==='day' || groupingType === 'month' || groupingType==='year' || groupingType ==='range'|| groupingType ==='quarter'">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{ytdTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yearly2Mt | number : '1.2-2'}} mt</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yearly2Budget | number :
                                                '1.2-2'}} mt</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly2VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yearly1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yearly2VarMt | number : '1.2-2'}} mt
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{yphTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{yph2Mt | number : '1.2-2'}} mt/ha</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{yph2Budget | number : '1.2-2'}}
                                                mt/ha</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="yph1VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yph2VarPer | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="yph1VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{yph2VarMt | number : '1.2-2'}} mt/ha
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-12 col-sm-12">
                            <div class="card ext-card">
                                <div class="card-body">
                                    <p class="text-muted mb-4 card-title"><i
                                            class="bx bx-spa h1 text-success align-middle mb-0 me-3"></i>{{matureAreaTextCompare2}}
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <span class="card-val">{{ha2Mt | number : '1.2-2'}} ha</span>
                                            <br />
                                            <span class="text-muted mb-0 card-variance-budget">Budget:
                                            </span>
                                            <span class="card-variance-budget">{{ha2Budget | number : '1.2-2'}}
                                                ha</span>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var: </span><span
                                                        class="badge font-size-12 card-variance"
                                                        [ngClass]="ha2VarMt >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{ha2VarMt | number : '1.2-2'}} %</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="d-flex card-variance-container">
                                                    <span class="text-truncate card-variance">Var:
                                                    </span><span class="badge font-size-12 card-variance"
                                                        [ngClass]="ha2VarPer >= 0 ? 'badge-soft-success':'badge-soft-danger'">
                                                        {{ha2VarPer | number : '1.2-2'}} ha
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white"> Loading.. </p>
</ngx-spinner>